module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-152x152-a8745f422053dba33e540b3df5b598fa.png";